export default "<div\n  class=\"loading-box\"\n  [ngClass]=\"{ rounded: rounded }\"\n  [style.paddingTop]=\"full ? '100%' : height + 'px'\"\n></div>\n"